// FormShell — Presentational outer card wrapper, header (Plus icon +
// "Create Trip Manually"), descriptive paragraph, and the <form> element.
// Renders `children` inside the form.
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// icon usage, and text strings are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { Plus } from 'lucide-react';

export const FormShell = React.memo(function FormShell({ onSubmit, children, afterForm }) {
  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      padding: '40px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '20px'
      }}>
        <Plus size={24} style={{ color: '#0ea5e9' }} />
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          margin: '0'
        }}>
          Create Trip Manually
        </h2>
      </div>
      
      <p style={{
        color: '#6b7280',
        fontSize: '16px',
        margin: '0 0 30px 0',
        lineHeight: '1.5'
      }}>
        Create a trip by entering the basic details. You can add flights, hotels, and other events later.
      </p>

      <form onSubmit={onSubmit}>
        {children}
      </form>
      {afterForm}
    </div>
  );
});

export default FormShell;
